// extracted by mini-css-extract-plugin
module.exports = {"icon":"items_icon__1DUNt","item":"items_item__r0UXN","split":"items_split__36cCD"};